import { Component, ViewChild, ElementRef } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';


import { MateriaisService } from '../../../../providers/materiais-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';
import { IMyDateModel, IMyDpOptions } from 'mydatepicker';

declare var jsPDF: any;

@Component({
    selector: 'page-bens-doacao',
    templateUrl: 'bens-doacao.html',
    providers: [
        MateriaisService
    ]
})
export class BensDoacaoPage extends ModulosController {
    listaDados: any = [];
    loading: boolean = true;
    idSecaoPagina: string = "167";
    tiposArquivosAceitos: string = "application/xls";
    dadosImportados: any[];

    myDatePickerPublicacao: IMyDpOptions;
    private placeholder: string = 'Informe a Data';

    page1: number = 1;

    relatorioParaAdicionar: any = {
        descricaoItem: '',
        numeroDecreto: '',
        numeroTombamento: '',
        valorBaixa: '',
        dataPublicacao: '',
        idModuloAnalise: ''
    }

    objetoEdit: any = null;
    listEdit: any = [];
    analise: any = null;

    @ViewChild('inputFileCM')
    inputFileCMVar: ElementRef;

    selecionarTodosChecked = false;

    totalValorBaixa = 0;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public materiaisService: MateriaisService,
        private fileService: FileService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

        this.analise = this.navParams.get('analise');

        this.carregarDados();
        this.setModuloId(13);

        this.myDatePickerPublicacao = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false
            //disableUntil: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() - 1 }
        };

    }

    carregarDados() {
        this.materiaisService.listarBaixaBensDoacao().subscribe(data => {
            this.listaDados = data;
            this.totalizarValores();
            this.selecionarTodosChecked = false;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });       
    }

    fileChange(event) {
        this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
            if (callback) {
                this.loading = true;
                this.fileService.cargaBaixaBensDoacao(event, this.idSecaoPagina).subscribe(data => {
                    this.inputFileCMVar.nativeElement.value = "";
                    this.dadosImportados = data;

                    for (let j = 0; j < this.dadosImportados.length; j++) {
                        this.listaDados.push(this.dadosImportados[j]);                        
                    }

                    this.totalizarValores();

                    this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");         
                    this.loading = false;

                    }, error => {
                    this.inputFileCMVar.nativeElement.value = "";
                    this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error.mensagem);
                    this.loading = false;
                });
            } else {
                this.inputFileCMVar.nativeElement.value = "";
            }
        });
    }

    downloadDoModelo() {
        this.fileService.downloadModeloCargaGestaoMateriais(this.idSecaoPagina);
    }

    adicionarRelatorio() {

        if (this.relatorioParaAdicionar.descricaoItem != '' &&
            this.relatorioParaAdicionar.numeroDecreto != '' &&
            this.relatorioParaAdicionar.numeroTombamento != '' &&
            this.relatorioParaAdicionar.valorBaixa != '' &&
            this.relatorioParaAdicionar.dataPublicacao != '') {

            if (this.relatorioParaAdicionar.valorBaixa == "" || this.relatorioParaAdicionar.valorBaixa == null || this.relatorioParaAdicionar.valorBaixa == undefined || isNaN(this.relatorioParaAdicionar.valorBaixa)) {
                this.relatorioParaAdicionar.valorBaixa = 0;
            } else {
                this.relatorioParaAdicionar.valorBaixa = this.relatorioParaAdicionar.valorBaixa;
            }

            let relatorioNovo = {
                "id": 0,
                "descricaoItem": this.relatorioParaAdicionar.descricaoItem,
                "numeroDecreto": this.relatorioParaAdicionar.numeroDecreto,
                "numeroTombamento": this.relatorioParaAdicionar.numeroTombamento,
                "valorBaixa": this.relatorioParaAdicionar.valorBaixa,
                "dataPublicacao": this.relatorioParaAdicionar.dataPublicacao,
                "idModuloAnalise": 0

            }

            if (this.objetoEdit) {
                let index = this.listaDados.indexOf(this.objetoEdit);
                this.listaDados.splice(index, 1);

                relatorioNovo.id = this.objetoEdit.id;

                this.listEdit.push(this.objetoEdit);
            }

            this.listaDados.push(relatorioNovo);
            this.totalizarValores();
            this.objetoEdit = null;

            this.selecionarTodosChecked = false;

            this.relatorioParaAdicionar.descricaoItem = '';
            this.relatorioParaAdicionar.numeroDecreto = '';
            this.relatorioParaAdicionar.numeroTombamento = '';
            this.relatorioParaAdicionar.valorBaixa = '';
            this.relatorioParaAdicionar.dataPublicacao = null;

            this.salvar(true);
        }
        else {
            this.alertService.mostraAlerta("", "Verifique os campos do formulário não preenchidos.");
            return;
        }
    }

    remover(item, edit) {

        if (!edit) {
            this.alertService.mostraModalConfirmacao("Remover Item", "Deseja remover o item?", callback => {
                if (callback) {

                    let index = this.listaDados.indexOf(item);
                    this.listaDados.splice(index, 1);

                    if (item.id != "0") {
                        this.materiaisService.deletarBaixaBensDoacao(item.id).subscribe(data => {
                        }, error => {
                            this.alertService.mostraAlerta("", "Ocorreu um erro ao remover o registro: " + error);
                            this.carregarDados();
                        });
                    }
                }
            });
        } else {
            let index = this.listaDados.indexOf(item);
            this.listaDados.splice(index, 1);

            if (item.id != "0") {
                this.materiaisService.deletarBaixaBensDoacao(item.id).subscribe(data => {
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao remover o registro: " + error);
                    this.carregarDados();
                });
            }
        }
    }

    excluirSelecionados(){

        let qtdeSelecionados = 0; 
        this.listaDados.forEach(item => qtdeSelecionados += item.checked);
        
        if(qtdeSelecionados == 0) {
            this.alertService.mostraAlerta("", "Selecione pelo menos um registro para excluir!");
            return;
        }
    
        let registrosTexto = qtdeSelecionados + (qtdeSelecionados == 1 ? " registro?" : " registros?");
    
        this.alertService.mostraModalConfirmacao("Excluir " + registrosTexto, 
            "Deseja continuar com a exclusão de " 
                + registrosTexto + "<br/>" 
                + "Após a exclusão, os registros serão recarregados. Certifique-se de salvar possíveis alterações antes de prosseguir!", 
            callback => {            
                if (callback) {
                    this.loading = true;
                                        
                    let listaId = this.listaDados
                        .filter(item => item.checked)
                        .map(item => item.id);
                    
                    this.materiaisService.deletarBaixaLista(listaId).subscribe(data => {
                        this.loading = false;
                        this.carregarDados();
                        this.alertService.mostraAlerta("", data.mensagem);
                    }, error => {
                        this.loading = false;
                        this.carregarDados();
                        this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir: " + error.mensagem);
                    });
                }
            }
        );        
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaMateriais() {
        this.menuService.redirecionarPagina(this.materiaisService.obterIdPaginaMateriais());
    }

    onDatePickerDataPub(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.relatorioParaAdicionar.dataPublicacao = null;
        }
        else {
            this.relatorioParaAdicionar.dataPublicacao = new Date(event.jsdate).toLocaleDateString('pt-br');
        }
    }


    salvar(add) {
        this.loading = true;

        // this.listEdit.forEach(item => {
        //     this.remover(item.id, true);
        // });

        this.listEdit = [];

        this.materiaisService.salvarBaixaBensDoacao(this.listaDados).subscribe(data => {
           
            if (!add) {
                this.alertService.mostraAlerta("", "Salvo com sucesso.");
              } else {
                console.log("Salvo com sucesso...");
              }

            this.carregarDados();
            this.loading = false;
        }, error => {

            if (!add) {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar: " + error.mensagem);
              } else {
                console.log("Ocorreu um erro ao salvar...");
              }
            this.loading = false;
        })
    }

    finalizar() {
        this.loading = true;

        this.listEdit.forEach(item => {
            this.remover(item.id, true);
        });

        this.listEdit = [];

        if (this.listaDados) {
            this.materiaisService.finalizarBaixaBensDoacao(this.listaDados).subscribe(data => {
                this.alertService.mostraAlerta("", "Finalizado com sucesso.");
                this.voltarParaMateriais();
                this.loading = false;
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar: " + error.mensagem);
                this.loading = false;
            });
        }
    }

    editar(item) {
        this.relatorioParaAdicionar.descricaoItem = item.descricaoItem;
        this.relatorioParaAdicionar.numeroDecreto = item.numeroDecreto;
        this.relatorioParaAdicionar.numeroTombamento = item.numeroTombamento;
        this.relatorioParaAdicionar.valorBaixa = item.valorBaixa;
        this.relatorioParaAdicionar.dataPublicacao = item.dataPublicacao;

        this.objetoEdit = item;
    }

    printData() {

        var doc = new jsPDF("l");

        var totalPagesExp = "{total_pages_count_string}";

        this.materiaisService.listarBaixaBensDoacao().subscribe(listaCompleta => {
            var pageContent = function (data) {
                // HEADER
                doc.setFontSize(20);
                doc.setTextColor(40);
                doc.setFontStyle('normal');

                doc.text("Baixa de Bens por Doação", data.settings.margin.left + 15, 22);

                // FOOTER
                var str = "Page " + data.pageCount;
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    str = str + " of " + totalPagesExp;
                }
                doc.setFontSize(10);
                doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
            };

            var columns = [
                { title: "Item", dataKey: "item" },
                { title: "Nº Decreto", dataKey: "decreto" },
                { title: "Data Public.", dataKey: "dataPub" },
                { title: "Nº Tombamento", dataKey: "tomb" },
                { title: "Valor da Baixa", dataKey: "valor" }
            ];

            let rows = [];

            listaCompleta.forEach(element => {

                var item = {
                    "item": element.descricaoItem != null ? element.descricaoItem : "",
                    "decreto": element.numeroDecreto != null ? element.numeroDecreto : "",
                    "dataPub": element.dataPublicacao != null ? element.dataPublicacao : "",
                    "tomb": element.numeroTombamento != null ? element.numeroTombamento : "",
                    "valor": element.valorBaixa != null ? this.formatarValorNumerico(element.valorBaixa) : ""
                };

                rows.push(item);
            });

            doc.autoTable(columns, rows, {
                //     theme: 'grid',
                //     addPageContent: pageContent,
                //     margin: { top: 30 },
                //     styles: {
                //         overflow: 'linebreak', // visible, hidden, ellipsize or linebreak
                //         columnWidth: 'auto'
                //     }
                // });

                theme: 'grid',
                addPageContent: pageContent,
                margin: {
                    top: 30,
                    left: 5
                },
                styles: {
                    overflow: 'linebreak',
                    columnWidth: 'wrap',
                    fontSize: 10
                },
                columnStyles: {
                    text: { columnWidth: 'auto' },
                    item: { columnWidth: 55 },
                    decreto: { columnWidth: 55 },
                    dataPub: { columnWidth: 25 },
                    tomb: { columnWidth: 55 },
                    valor: { columnWidth: 25 }
                }
            });

            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp);
            }

            doc.save('bens_doacoes.pdf');
        });
    } 
    
    selecionarTodos(){
        setTimeout(()=>{
            this.listaDados.forEach(
                item => item.checked = this.selecionarTodosChecked);            
        });
    }
    
    selecionarItem(){
        const totalItems = this.listaDados.length;
        let checked = 0;
        this.listaDados.map(obj => {
            if (obj.checked) checked++;
        });
        this.selecionarTodosChecked = checked == totalItems;
    }

    totalizarValores() {
        this.totalValorBaixa = 0;
    
        this.listaDados.forEach(element => {
            this.totalValorBaixa += element.valorBaixa;
        });    
      }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/materiais/bens-doacao/bens-doacao.ts